import { Button, styled } from "@mui/material";

export const TabButton = styled(Button)(
  ({ theme, "aria-current": ariaCurrent }) => ({
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    height: 48,
    backgroundColor: ariaCurrent
      ? theme.vars.palette.backgrounds.neutral.strong.default
      : theme.vars.palette.backgrounds.static.neutral,
    color: theme.vars.palette.texts.neutral.contrast,
    "&:hover": {
      backgroundColor: theme.vars.palette.backgrounds.neutral.strong.hover,
    },
    "&:active": {
      backgroundColor: theme.vars.palette.backgrounds.neutral.strong.pressed,
    },
  }),
) as typeof Button;
